var publicPath = __webpack_public_path__;
                    var symbolUrl = 'gfx/sprite.svg#icon-language-eng';
                    var viewUrl = 'gfx/sprite.svg#view-icon-language-eng';

                    

                    module.exports = {
                        symbol: publicPath + symbolUrl,
                        view: publicPath + viewUrl,
                        viewBox: '0 0 24 24',
                        title: '',
                        toString: function () {
                            return JSON.stringify(this.view);
                        }
                    };